(function (ws) {
    'use strict';
    ws.views.threepllistingTable = ws.views.simpleTable.extend({

        /**
         * Events override
         */
        events: _.extend({}, ws.views.simpleTable.prototype.events, {
            'click .tbl-magnifying': 'triggerSearch',
            'click .order-export-checkbox-selectAll': 'toggleAllCheckboxes',
            'click .export-multiOrderLicence': 'downloadMultipleOrder',
            'click .order-export-checkbox': 'enableDownlodButton'
        }),

        /**
         * Initialize override
         */
        initialize: function () {
            this.$table = this.$('#order-table');
            this.searchUrl = globals.path.api.westcon.threePLInboundRequests;
            this.export3PLrequests = globals.path.api.westcon.threePLInboundRequestsExport;
            this.rowTemplate = this.$('#orderlisting-table-row');
            this.overrideFilterRequest = true;
            this.$searchInput = this.$('.tbl-simple-searchInput');
            this.$selectAllCheckbox = this.$('.order-export-checkbox-selectAll');

            this.controlColumn = 0;

            this.licencePerPageValue = this.$('.licence-listing-perpage');
            this.multiViewEnabled = this.$('#multiViewEnabled').val();

            ws.views.simpleTable.prototype.initialize.call(this);

            //Making the select dropdowns without scroll and without search textbox
            $('.tbl-simple-filters select').select2({
                minimumResultsForSearch: Infinity,
                dropdownAutoWidth: true,
                dropdownCssClass: 'comp-order-table'
            });

            this.$selectAllCheckbox.attr('checked', false);
            this.$('.order-export-checkbox').prop('checked', false);
            this.enableDownlodButton();
            this.searchFilter();

        },

        /**
         * Search
         * @param {Object} e
         */
        search: function (e) {
            if (e.which === 13) {
                this.eventAgg.trigger('resetSortColumns');
                ws.views.simpleTable.prototype.search.call(this, e);
            }
        },

        /**
         * Call Search Filter API
         * Overriding from the parent view
         * @param {Object} request
         */
        searchFilterCall: function (request) {
            this.model.clear();
            this.model.set(request);
            this.unsetParams();
            this.model.url = this.searchUrl;
            this.$table.dataTable().fnClearTable();
            this.$table.dataTable().fnDestroy();
            this.$table.DataTable().destroy();

            this.$tableSpinner.show();
            this.$emtpyTableCopy.hide();

            $.each(this.$tableHeaders, function (i, th) {
                $(th).removeClass('loaded');
            });

            // calling without arguments to hide pagination
            this.calculateShowing();
            this.calculatePagination();
            this.enableDelaySpinner();
            $('.invalid-order').hide();

            //if request has value for search text, need to show search filter
            if (request.searchText !== '') {
                this.showClearFilterButton = true;
            }

            this.model.save().done(function (data) {
                this.$tableSpinner.hide();
                this.disabledDelaySpinner();
                this.renderRows(data.results);

                this.checkSelectAllCheckbox();
                this.calculateShowing(data.pagination);
                this.calculatePagination(data.pagination);
                this.$pagination.addClass('search');
                this.$clearFilterButton.toggle(this.showClearFilterButton);
                if (this.showClearFilterButton) {
                    this.$('.message-link').hide();
                }

                this.toggleApplySearchBtn(true);

            }.bind(this)).fail(function () {
                this.tableGenericError();
                this.disabledDelaySpinner();
            }.bind(this));
        },

        /**
         *  Enable the download button and disable Download Button
         */
        enableDownlodButton: function () {
            var $checkboxes = this.$('.order-export-checkbox');
            var flag = 1;
            _.each($checkboxes, function(checkbox) {
                if ($(checkbox).is(':checked')) {
                    $('.export-multiOrderLicence').attr('disabled', false);
                    flag = 0;
                } else {
                    $('.order-export-checkbox-selectAll').prop('checked', false);
                }
            });

            if (flag === 1) {
                $('.export-multiOrderLicence').attr('disabled', true);
            }

            this.checkSelectAllCheckbox();
        },

        /**
         * Overiding the Render a table row from the parent
         * @param {Object} result
         */
        renderRows: function (result) {
            var options;
            var _this = this;
            _.each(result, function (row) {
                row.multiViewEnabled = $('#multiViewEnabled').val();

                options = {
                    model: row,
                    rowTemplate: _this.rowTemplate
                };
                var tableRow = new ws.views.simpleTableRows(options);
                _this.$table.append(tableRow.render().el);
            });

            this.fadeInRows();
            this.initializeDataTable();

            if (this.sortColumn) {
                this.$table.find('th[data-attr=' + this.sortColumn + ']').addClass('sorting_' + this.sortCode);
            }
        },

        /**
         * Check select all checkbox and check/uncheck
         */
        checkSelectAllCheckbox () {
            const totalCheckboxes = $('.order-export-checkbox').not(':disabled').length;
            const selectedCheckboxes = $('.order-export-checkbox:checked').not(':disabled').length;
            if (selectedCheckboxes == 0) {
                this.$selectAllCheckbox.prop('checked', false);
            } else {
                this.$selectAllCheckbox.prop('checked', totalCheckboxes === selectedCheckboxes);
            }
        },

        /**
         * Change the state of all the checkboxes in the Order Listing table table.
         * @param {Object} ev
         */
        toggleAllCheckboxes: function (ev) {
            var $checkboxes = this.$('.order-export-checkbox').not(':disabled');
            var $checkboxAll = this.$('.order-export-checkbox-selectAll');
            _.each($checkboxes, function(checkbox) {
                $(checkbox).prop('checked', $checkboxAll.is(':checked'));
            });

            this.enableDownlodButton();
        },

        /**
         * Downloading the multiple orders excel functionality
         */
        downloadMultipleOrder: function () {
            globals.disableApp();
            let _this = this;
            var $checkboxes = this.$('.order-export-checkbox');
            var inboundReqList = [];
            _.each($checkboxes, function(checkbox) {
                if ($(checkbox).prop('checked') === true && $(checkbox).prop('disabled') !== true) {
                    inboundReqList.push($(checkbox).data('attr'));
                }
            });

            const CSRFToken = $('#CSRFToken').val();
            const urlExportOrderList = this.export3PLrequests + '?CSRFToken=' + CSRFToken;
            const data = {
                inboundReqList: inboundReqList
            };

            // DOWNLOADING EXCEL FILE FROM THE BLOB.
            const xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                var a;
                if (xhttp.readyState === 4 && xhttp.status === 200) {
                    // Trick for making downloadable link
                    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
                        navigator.msSaveBlob(xhttp.response, 'licenseDownload.xls');
                    } else {
                        a = document.createElement('a');
                        a.href = window.URL.createObjectURL(xhttp.response);

                        // Give filename you wish to download
                        a.download = '3PLRequestDownload.xls';
                        a.style.display = 'none';
                        document.body.appendChild(a);
                        a.click();
                    }

                    _this.checkSelectAllCheckbox();
                    globals.enableApp();
                }
            };

            xhttp.open('POST', urlExportOrderList);
            xhttp.setRequestHeader('Content-Type', 'application/json');
            xhttp.responseType = 'blob';
            xhttp.send(JSON.stringify(data));
        },

        /**
         * Trigger Search
         */
        triggerSearch: function () {
            this.eventAgg.trigger('resetSortColumns');
            const e = $.Event('keypress', {which: 13});
            this.$searchInput.trigger(e);
        },

        /**
         * Override filter request object
         * @param {Object} request
         */
        customFilterRequest: function (request) {
            return _.extend({}, request, {
                manufacturer: request.status,
                status: ''
            });
        },

        /**
         * Update Pikaday end date
         */
        pikadayUpdateEndDate: function (startPicker, endPicker, endDate) {
            if (endDate) {
                startPicker.pikaday('setMinDate', startPicker);
            }
        },

        /**
         * simple table override to get table data
         */
        getClearFilterTableData: function (e) {
            if (e != undefined) {
                globals.disableApp();
                this.enableDownlodButton();

                //reset sort columns. avoiding event trigger
                this.sortCode = null;
                this.sortColumn = null;
                this.$sortableColumns.removeClass('asc').removeClass('desc');
                this.searchFilter();
                this.$selectAllCheckbox.attr('checked', false);
                globals.enableApp();
            }
        },

        /**
         * need not set history. we need to optimize setting history since there are multiple states pushed for single url change
         */
        setHistory: function () {

        },

        disableFutureDate: true
    });
})(westcon);
